module.exports = __webpack_public_path__ + "img/part2.40305567.png";